import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Stack } from 'react-bootstrap';
import { asve } from '../orve';
import { getTipContent, shuffleArray } from '../report-util';
import AcumenTips from './acument-tips';
import { REPORT_TYPE } from '../../../../utils/constants';

function RecommendationsPersonalityTips({
  candidate,
  nTips = 1,
  withAcumen = false,
  tipsIntro = undefined,
  reportType = REPORT_TYPE.coaching,
}) {
  const [tips1, setTips1] = useState([]);
  const [tips2, setTips2] = useState([]);
  const [tips3, setTips3] = useState([]);
  const [tips4, setTips4] = useState([]);
  const [initialized, setInitialized] = useState(false);

  const getTips = useCallback(
    (score, tips) => {
      const tipsContent = [];
      for (let t = 0; t < nTips; t++) {
        tipsContent.push(
          <Stack direction="horizontal" className="pb-2" key={t}>
            <div>{getTipContent(tips[t].title, score, tips[t].text, undefined, reportType)}</div>
          </Stack>
        );
      }
      return tipsContent;
    },
    [nTips]
  );

  useEffect(() => {
    if (!initialized && candidate) {
      switch (reportType) {
        case REPORT_TYPE.staffing:
          setTips1(shuffleArray(candidate, asve(candidate).staffingPersonalityConscientiousnessTips));
          setTips2(shuffleArray(candidate, asve(candidate).staffingPersonalityHonestyHumilityTips));
          setTips3(shuffleArray(candidate, asve(candidate).staffingPersonalityEmotionalControlTips));
          setTips4(shuffleArray(candidate, asve(candidate).staffingPersonalityAgreeablenessTips));
          break;
        case REPORT_TYPE.development:
          setTips1(shuffleArray(candidate, asve(candidate).developmentPersonalityConscientiousnessTips));
          setTips3(shuffleArray(candidate, asve(candidate).developmentPersonalityExtraversionTips));
          setTips2(shuffleArray(candidate, asve(candidate).developmentPersonalityHonestyHumilityTips));
          setTips4(shuffleArray(candidate, asve(candidate).developmentPersonalityEmotionalControlTips));
          break;
        default:
          setTips1(shuffleArray(candidate, asve(candidate).personalityConscientiousnessTips));
          setTips2(shuffleArray(candidate, asve(candidate).personalityExtraversionTips));
          setTips3(shuffleArray(candidate, asve(candidate).personalityHonestyHumilityTips));
          setTips4(shuffleArray(candidate, asve(candidate).personalityEmotionalControlTips));
      }
      setInitialized(true);
    }
  }, [candidate]);

  return (
    <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
      {initialized && (
        <>
          <Row className="justify-content-center pt-4">Development & Coaching Recommendations</Row>
          <Row className="justify-content-center w-25 mx-auto pt-3">
            <hr style={{ borderTop: '2px solid' }} />
          </Row>
          <Row className="justify-content-center pt-1 pb-1 candidate-profile-candidate-name">{candidate.name}</Row>
          <Row className="w-100 mx-auto pb-4">
            {tipsIntro ? (
              <>{tipsIntro}</>
            ) : (
              <div>
                The recommendations included in this report are targeted tips that will be beneficial for this
                individual based on the assessment results. Taking action on provided tips will have immediate impact to
                boost performance and loyalty. While most of these tips are aimed at helping individuals improve lower
                scoring assessments, research has found individuals also need to remain focused on certain high scoring
                areas.
              </div>
            )}
          </Row>
          <h3 className="pt-4">PERSONALITY</h3>
          {reportType !== REPORT_TYPE.staffing ? (
            <>
              <Row className="w-100 mx-auto justify-content-center pt-1 pb-3">
                {getTips(candidate.personality?.scores.conscientiousness.overall, tips1)}
                {getTips(candidate.personality?.scores.extraversion.overall, tips2)}
                {getTips(candidate.personality?.scores.honestyHumility.overall, tips3)}
                {getTips(candidate.personality?.scores.emotionalControl.overall, tips4)}
              </Row>
              {withAcumen && <AcumenTips candidate={candidate} reportType={reportType} />}
            </>
          ) : (
            <Row className="w-100 mx-auto justify-content-center pt-1 pb-3">
              {getTips(candidate.personality?.scores.conscientiousness.overall, tips1)}
              {getTips(candidate.personality?.scores.honestyHumility.overall, tips2)}
              {getTips(candidate.personality?.scores.emotionalControl.overall, tips3)}
              {getTips(candidate.personality?.scores.agreeableness.overall, tips4)}
            </Row>
          )}
        </>
      )}
    </Container>
  );
}

export default RecommendationsPersonalityTips;
